import { useMemo } from "react";
import {
  Paper,
  Typography,
  Box,
} from "@mui/material";
import WGRTable from "./faTable";


//import WGRTotals from "./iohTotals";

export default function WGRShopGroup({
  shop,
  rows,
}) {
  /*
   * Shop Total
   */
  const totals = useMemo(() => {
      return rows.reduce(
        (total, row) => ({
  
          BulkOrder:
            total.BulkOrder +
            Number(row.BulkOrder || 0),
  
  
  
          DRR:
            total.DRR +
            Number(row.DRR || 0),
  
          Electrical:
            total.Electrical +
            Number(row.Electrical || 0),
  
          Labour:
            total.Labour +
            Number(row.Labour || 0),
  
          POH:
            total.POH +
            Number(row.POH || 0),
  
          ReturnStore:
            total.ReturnStore +
            Number(row.ReturnStore || 0),
  
          freight:
            total.freight +
            Number(row.freight || 0),
  
          proforma:
            total.proforma +
            Number(row.proforma || 0),
  
          revenue:
            total.revenue +
            Number(row.revenue || 0),
  
          store:
            total.store +
            Number(row.store || 0),
  
  
  
  
        }),
  
  
  
  
        {
          BulkOrder: 0,
          DRR: 0,
          Electrical: 0,
          Labour: 0,
          POH: 0,
          ReturnStore: 0,
          freight: 0,
          proforma: 0,
          revenue: 0,
          store: 0,
  
        }
      );
    }, [rows]);

  return (
    <Paper
      elevation={2}
      sx={{
        overflow: "hidden",
        borderRadius: 2,
      }}
    >
      {/* Shop Header */}

      {/* <Box
        sx={{
          bgcolor: "primary.main",
          color: "white",
          px: 2,
          py: 1,
          mt:5,
          minHeight:20,
        }}
      >
        <Typography
          variant="h6"
          fontWeight={700}
        >
          Railway  : {shop}
        </Typography>
      </Box> */}

      {/* Detail Table */}

     

      {/* Shop Total */}
 {/* THIS IS WHERE WGRTable SHOULD BE */}
   <WGRTable
  rows={rows}
  shop={shop}
  totals={totals}
  showTotal={true}
/>
      
        
    </Paper>
  );
}

